import {splitISOToLocalDate} from '@/helpers/dateUtils'

export const getDisplayValue = (value, renderer) => {
  if (renderer === 'toggle') {
    return value === true || value === 'true' ? 'Yes' : 'No'
  }
  
  if (Array.isArray(value)) {
    if (!value.length) return '-'
    if (value[0]?.segmentName !== undefined) {
      return value.map(s => s.segmentName).filter(Boolean).join(', ') || '-'
    }
    return value.join(', ')
  }

  if (value && typeof value === 'object') {
    const values = Object.values(value).filter(Boolean)
    return values.length ? values.join(', ') : '-'
  }

  if (renderer === 'date') {
    return typeof value === 'string' ? splitISOToLocalDate(value) : '-'
  }

  return value ?? '-'
}

/**
 * Converts a value to a number when it parses as a finite number, otherwise returns the value
 * unchanged. Used so partial/invalid input (e.g. a lone `-` while typing, or empty string) isn't
 * clobbered before validation runs, while valid numeric input is stored as a real number rather
 * than a string (for example, the backend expects `displaySizeId` as a JSON number).
 * @param {unknown} value Value to convert.
 * @returns {unknown} Number when parseable, otherwise the original value.
 */
export const toNumberOrRaw = value => {
  if (value === '' || value === null || value === undefined) return value

  const numericValue = Number(value)

  return Number.isFinite(numericValue) ? numericValue : value
}
